export default __webpack_public_path__ + "5d96afc173c85ffe3e4b53ec0a41151a.png";